module.exports = __webpack_public_path__ + "img/chevron-down-red.35c3a297.svg";